// =============================================
// File: src/services/memberService.js
// =============================================

import axiosInstance from "./axiosInstance";

// Get all members
export const getMembers = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/members', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching members:', error);
    throw error;
  }
}

// Get single member by ID
export const getMemberById = async (id) => {
  try {
    const response = await axiosInstance.get(`/members/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching member:', error);
    throw error;
  }
}

// Create new member
export const createMember = async (memberData) => {
  try {
    const response = await axiosInstance.post('/members', memberData);
    return response.data;
  } catch (error) {
    console.error('Error creating member:', error);
    throw error;
  }
}

// Update member
export const updateMember = async (id, memberData) => {
  try {
    const response = await axiosInstance.put(`/members/${id}`, memberData);
    return response.data;
  } catch (error) {
    console.error('Error updating member:', error);
    throw error;
  }
}

// Delete member
export const deleteMember = async (id) => {
  try {
    const response = await axiosInstance.delete(`/members/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting member:', error);
    throw error;
  }
}

// Get member usage history
export const getMemberUsageHistory = async (id) => {
  try {
    const response = await axiosInstance.get(`/members/${id}/usage-history`);
    return response.data;
  } catch (error) {
    console.error('Error fetching usage history:', error);
    throw error;
  }
}

// Use a service from member's plan
export const useServiceFromMemberPlan = async (memberId, usageData) => {
  try {
    const response = await axiosInstance.post(`/members/${memberId}/use-service`, usageData);
    return response.data;
  } catch (error) {
    console.error('Error using service:', error);
    throw error;
  }
}

// Get members with expiring plans
export const getExpiringMembers = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/members/expiring', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching expiring members:', error);
    throw error;
  }
}

// Renew member's plan
export const renewMemberPlan = async (memberId, renewalData) => {
  try {
    const response = await axiosInstance.post(`/members/${memberId}/renew-plan`, renewalData);
    return response.data;
  } catch (error) {
    console.error('Error renewing plan:', error);
    throw error;
  }
}

// Get member statistics
export const getMemberStats = async (companyId) => {
  try {
    const response = await axiosInstance.get(`/members/stats`, { params: { companyId } });
    return response.data;
  } catch (error) {
    console.error('Error fetching member stats:', error);
    throw error;
  }
}